<template>
  <div>
    <form role="form" id="lead-settings-form">
      <div class="form-group">
        <label for="defaultProspectCoach" class="font-semi m-b-xxs">
          Default coach for new inquiries
        </label>
        <p class="font-normal m-b-sm">
          When a new lead fills out your public inquiry form,
          they'll be assigned to this coach automatically.
          You can always reassign later from the lead's detail page.
        </p>
        <select id="defaultProspectCoach" class="form-control" v-model="defaultProspectCoachId">
          <option :value="null">No default &mdash; leave unassigned</option>
          <option v-for="coach in coaches" :key="coach.id" :value="coach.id">
            {{ coach.first_name }} {{ coach.last_name }}
          </option>
        </select>
      </div>

      <ladda-button @lbClicked="save" el-class="btn-primary m-t-m" :loading="saving">
        Save
      </ladda-button>
      <div v-if="error">
        <small><span class="text-danger">{{ errorMessage }}</span></small>
      </div>
    </form>
  </div>
</template>

<script>
import LaddaButton from '../../shared/ladda_button.vue';
import { errorableMix } from './mixins/errorable_mix';

export default {
  name: 'lead-settings',
  components: { LaddaButton },
  mixins: [errorableMix],
  props: {
    teamId: {
      type: Number,
      required: true,
    },
    initialDefaultCoachId: {
      type: [Number, String],
      default: null,
    },
    coaches: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      defaultProspectCoachId: null,
      saving: false,
    };
  },
  mounted() {
    this.defaultProspectCoachId = this.initialDefaultCoachId;
  },
  methods: {
    save: _.throttle(function () {
      if (this.saving) {
        return;
      }

      const vm = this;
      vm.saving = true;
      const url = vm.$apiService.teamUrl(vm.teamId);
      const data = {
        team: {
          default_prospect_coach_id: vm.defaultProspectCoachId,
        },
      };

      axios.put(url, data)
        .then(() => {
          vm.$notificationManager.emit('show-toast', 'Lead settings saved', true);
          vm.saving = false;
        })
        .catch((err) => {
          vm.saving = false;
          vm.errorMessage = `Error: ${err.toString()}`;
          vm.error = true;
        });
    }, 500),
  },
};
</script>
